import ROUTES from "../route/routes";

export function getRouteObj(url) {

    let currentPath = url !== '/' ? url.replace(/\/$/, "") : url;

    return Object.values(ROUTES).find(route => {
        return route.path === currentPath
    });
}